import * as React from "react";

import { PopoverTrigger } from "@replo/design-system/components/shadcn/core/popover";

export const ComboboxTrigger: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <PopoverTrigger asChild>{children}</PopoverTrigger>;
};
